import {Injectable} from '@angular/core';
import {Status} from '../../../../services/enums/status.enum';

@Injectable({
  providedIn: 'root'
})
export class OfflineDiagramMappersUtilsService {

  connectionStatusByLayer(dataItem, layerName): any {
    switch (layerName) {
      case 'topology':
        return connectionStatusTopologyLayer(dataItem);
      case 'quality' :
        return connectionStatusQualityLayer(dataItem);
    }

    function connectionStatusTopologyLayer(item): string {
      const connections = item.connections;

      if (item.type === 'NODE_TO_THIRD_PARTY') {
        return connections[0].operState === 'AVAILABLE' ? Status.GOOD : Status.BAD;
      } else {
        if (connections[0].operState === 'AVAILABLE' && connections[1].operState === 'AVAILABLE') {
          return Status.GOOD;
        } else {
          return Status.BAD;
        }
      }
    }

    function connectionStatusQualityLayer(item): string {

      switch (item.result) {
        case 'BAD':
          return Status.BAD;
        case 'FAIR':
          return Status.MEDIUM;
        case 'GOOD':
          return Status.GOOD;
        case 'UNKNOWN':
          return Status.UNKNOWN;
        default:
          return Status.GOOD;
      }
    }
  }

  peerConnectionStatusByLayer(dataItem, layerName): string {

    switch (layerName) {
      case 'topology':
        return peerConnectionStatusTopologyLayer(dataItem);
      case 'quality' :
        return peerConnectionStatusQualityLayer(dataItem);

    }

    function peerConnectionStatusTopologyLayer(data): string {

      if (data.operState !== 'AVAILABLE') {
        return Status.BAD;
      } else {
        return Status.GOOD;
      }
    }

    function peerConnectionStatusQualityLayer(data): string {

      switch (data.result) {
        case 'BAD':
          return Status.BAD;
        case 'FAIR':
          return Status.MEDIUM;
        case 'GOOD':
          return Status.GOOD;
        case 'UNKNOWN':
          return Status.UNKNOWN;
        default:
          return Status.GOOD;
      }
    }
  }
}
